
/* for things in public url like images dont need to include image prefix to path, start from root */

export const MainLogo = '/images/ic_launcher-web.png'
export const MainLogo2 = '/images/beaker3.png'
export const SideLandingPhoto = '/images/smiling3.jpg'
export const SideLandingPhoto2 = '/images/sunglasses2.jpg'